var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "exclamation-circle_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.807843 0 0 0 0 0.227451 0 0 0 0 0.188235 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FDECEB",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)",
    filter: "url(#exclamation-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M15.5 6v11"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 15.5,
    cy: 21.224,
    r: 1.5
  })))));
}
export default SvgExclamationCircle;